export default class AppEvents {
  static ModifyCurrentUserAcc = 'ModifyCurrentUserAcc';
}
